
import React, { useEffect, useState } from "react";
import { Menu, MenuProps, theme } from "antd";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import storage from "../../utils/storage";

function MenuComponent() {
  const StyledMenu = styled(Menu)`
  &.ant-menu-horizontal {
    border: none !important; // 去掉底部边框
    height: 40%;
  }
    

  .ant-menu-item::after,
 .ant-menu-submenu::after {
    border-bottom: none !important; /* 去掉底部的蓝色下边框 */
  }

  .ant-menu-item,
  .ant-menu-submenu-title {
    color: black !important; // 未选中样式
    font-weight: bold;
    &:hover {
      background-color: transparent !important; // 划过样式
      color: #aae260  !important;
      border-bottom: none !important; /* 去掉底部的蓝色下边框 */
    }
  }

  .ant-menu-item-selected {
    background-color: transparent !important; // 选中样式
    border-bottom: none !important; // 强制去掉默认的选中下划线
    color: #aae260  !important;
    &:hover {
      background-color: transparent !important; // 选中且划过样式
    }
  }

  .ant-menu-submenu-selected::after {
    border-bottom: none !important; /* 去掉选中时的蓝色下边框 */
  }

  .ant-menu-submenu-selected {
    background-color: transparent !important; // 选中样式
    border-bottom: none !important; // 强制去掉默认的选中下划线
    color: #aae260  !important;
    .ant-menu-submenu-title {
      color: #aae260  !important;
    }
  }
`;
const location=useLocation()
const navigate=useNavigate()
const [RoleValue, setRoleValue] = useState(storage.getItem("role"));
useEffect(()=>{
  setRoleValue(storage.getItem("role"))
},[storage.getItem("role")])
  const TopItems = [
    {
      label: (
        <a href="#/Breeding/home/" style={{fontSize:"19px", fontWeight: "bold" }}>
          Home
        </a>
      ),
      key: "1",
    },
{
  key:"2",
  label:(
    <a href="https://mfmgp.bioaibp.com/#/Breeding/MFMGP/" target="_blank" style={{fontSize:"19px", fontWeight: "bold" }}>
      MFMGP
    </a>
  ),
},
{
  key:"7",
  label:(
    <a href="#/Breeding/PFMGP"  style={{fontSize:"19px", fontWeight: "bold" }}>
      PFMGP
    </a>
  ),
},
    {
      label:(
        RoleValue=='A'?
        <a href="#/Breeding/introduction/"  style={{fontSize:"19px", fontWeight: "bold" }}>
          Pheno
        </a>:<a href="#/Breeding/introduction/" style={{fontSize:"19px", fontWeight: "bold" }}>Database</a>),
        key:"3"
    },
    {
      label: (
        <a href="#/Breeding/modelinter/"  style={{fontSize:"19px", fontWeight: "bold" }}>
          AIGS
        </a>
      ),
      key: "4",
    },
    {
      label: (
        <a href="#/Breeding/breedident/" style={{fontSize:"19px", fontWeight: "bold" }}>
          Breeding
        </a>
      ),
      key: "5",
    },
    {
      label: (
        <a href="#/Breeding/help/" style={{fontSize:"19px", fontWeight: "bold" }}>
          Help
        </a>
      ),
      key: "6",
    },
  ];
  const [current, setCurrent] = useState(
    storage.getItem("breedKey")
     || "1"
  );
  useEffect(()=>{
    setCurrent(storage.getItem("breedKey"))
  },[storage.getItem("breedKey")])


  useEffect(() => {
    // 根据当前路径设置当前选中的菜单项
    const pathToKey = {
      "/Breeding/home/": "1",
      "/Breeding/introduction/": "3",
      "/Breeding/modelinter/": "4",
      "/Breeding/breedident/": "5",
      "/Breeding/help/": "6",
    };

    const currentKey = pathToKey[location.pathname];
    if (currentKey) {
      setCurrent(currentKey);
      storage.setItem("breedKey", currentKey);
    }
  }, [location.pathname]);
  const onClick = (e) => {
    setCurrent(e.key);
    storage.setItem("breedKey", e.key);
    storage.setItem('BreedMenuKey','left1')
    storage.setItem('ModelMenuKey','left1')
    storage.setItem('PhenoMenuKey','left1')
  };

  return (
      <StyledMenu
        style={{width:"100%",  height: "50px",display:"flex",alignItems:"center" ,background:"transparent" }}
        onClick={onClick}
        selectedKeys={[current]}
        mode="horizontal"
        items={TopItems}
      />
  );
}

export default MenuComponent;
